<template>
    <div v-if="loading == false">
        <ChirpReport
            :data_source="rows"
            :export_report="export_report"
            :column_meta="headers"
            :loadingColumns="loadingTable"
            ignoreDateConversion
            :storeKey="storeKey"
            :useOverride="useOverride"
            @cancelOverride="useOverride = false"
            @rowSelected="onRowSelected"
            :hide_speed_date="false"
            :totalCount="totalCount"
        />
    </div>
</template>
<script>
    import { tryGetFilter } from '@/util/tryGetFilter';

    const api_root = 'reports';
    const report = 'attendance';
    import ChirpReport from '@/components/general/list/ChirpReport';
    export default {
        name: 'Attendance',
        components: { ChirpReport },
        props: {
            overrideFilter: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                rows: [],
                headers: [
                    { field: 'id', headerText: 'Client ID', hidden: true },
                    { field: 'client', headerText: 'Client', allowSorting: true },
                    { field: 'primary_counselor', headerText: 'Primary Counselor', allowSorting: true },
                    { field: 'required', headerText: 'Mandated?', allowSorting: true },
                    { field: 'attended', headerText: 'Attended', allowSorting: true }
                ],
                targetPage: 'ClientOverview',
                loading: true,
                loadingTable: false,
                useOverride: false,
                totalCount: 0,
                criteriaProps: {},
                export_report: 'attendance'
            };
        },
        computed: {
            criteria() {
                return this.useOverride && this.overrideFilter ? this.overrideCriteria : this.savedCriteria;
            },
            savedCriteria() {
                return tryGetFilter(this.$store, this.storeKey);
            },
            overrideCriteria() {
                return this.$store.getters['filters/overrideCriteria'](this.storeKey);
            },
            storeKey() {
                return this.pageMeta?.page || 'attendance';
            }
        },
        methods: {
            async load_data(criteria = this.criteria) {
                const body = {
                    criteria: {
                        ...criteria,
                        report
                    }
                };
                const res = await this.$api.post(`/${api_root}`, body);
                this.rows = res.data.rows.map((row) => ({
                    id: row.id,
                    client: row.client,
                    primary_counselor: row.primary_counselor || '--',
                    required: row.required == 0 ? 'No' : 'Yes',
                    attended: row.attended
                }));
                this.totalCount = res.data.total_count;

                if (
                    !criteria?.default_date_range ||
                    criteria?.default_date_range !== res.data.default_date_range
                ) {
                    this.$store.commit('filters/updateFilter', {
                        stateKey: this.storeKey,
                        criteria: {
                            ...criteria,
                            default_date_range: res.data.default_date_range
                        }
                    });
                }

                this.$nextTick(() => {
                    this.loading = false;
                });
            },
            async onRowSelected(data) {
                await this.$router.push({ name: 'ClientClinical', params: { client_id: data.id } });
            },
            async init() {
                if (this.overrideFilter) {
                    this.useOverride = true;
                    this.$store.commit('filters/applyOverride', {
                        stateKey: this.storeKey,
                        criteria: this.overrideFilter
                    });
                }

                await this.load_data();
            },
            async modifyCriteria(criteria) {
                if (this.targetPage) {
                    this.$store.commit('filters/update', {
                        criteriaPage: this.targetPage,
                        payload: criteria
                    });
                }
                this.criteriaProps = criteria;
                await this.load_data();
            }
        },
        async created() {
            await this.init();
        },
        watch: {
            criteria: {
                deep: true,
                async handler(newVal, oldVal) {
                    let updatedNewVal = { ...newVal };

                    if (Object.keys(newVal.sort).length === 0){
                        updatedNewVal.sort = oldVal.sort;
                    }

                    const newStr = JSON.stringify(updatedNewVal);
                    const oldStr = JSON.stringify(oldVal);
                    if (newStr !== oldStr) {
                        await this.load_data(updatedNewVal);
                    }
                },
            }
        }
    };
</script>
